module.exports = __webpack_public_path__ + "static/media/gym6.a1a5098a.jpg";